function isInt(value) {
  return value % 1 === 0;
}

export default isInt;
